import React from "react";
import Text from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";

const TextCard = ({ title, linkText, description, link, cmsHandler }) => {
  if (!title && !description && !link) return null;

  return (
    <div className="text-card" data-cy="Text Card">
      {title && (
        <Text {...title} cmsHandler={cmsHandler} cyData="Text Card Title" />
      )}
      {description && (
        <Text
          {...description}
          cmsHandler={cmsHandler}
          cyData="Text Card Description"
        />
      )}

      {link && (
        <div className="text-card-link-container">
          <CustomLink {...link} cmsHandler={cmsHandler}>
            <Text {...linkText} cmsHandler={cmsHandler} />
          </CustomLink>
        </div>
      )}
    </div>
  );
};

export default TextCard;
